async function createCustomerAccessToken() {
  try {
    const query = `
      mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {
        customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
          customerAccessToken {
            accessToken
            expiresAt
          }
          customerUserErrors {
            code
            field
            message
          }
        }
      }
    `;

    const match = document.cookie.match(/(?:^|; )multipassToken=([^;]*)/);
    const multipassToken = match ? decodeURIComponent(match[1]) : null;
    const variables = {
      multipassToken: multipassToken
    };

    const response = await fetch(`https://${window.SHOPIFY_DOMAIN}/api/2025-01/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": window.STOREFRONT_ACCESS_TOKEN
      },
      body: JSON.stringify({ query, variables })
    });

    const result = await response.json();
    const tokenData = result.data?.customerAccessTokenCreateWithMultipass;

    if (tokenData?.customerUserErrors?.length > 0) {
      console.error(tokenData.customerUserErrors.map(e => e.message).join(", "));
      return;
    }

    if (tokenData?.customerAccessToken?.accessToken) {
      const token = tokenData.customerAccessToken.accessToken;
      const expires = new Date(tokenData.customerAccessToken.expiresAt).toUTCString();

      document.cookie = `customerAccessToken=${token}; expires=${expires}; path=/; Secure; SameSite=Strict`;
    } else {
      console.error("Login failed. No token returned.");
    }

  } catch (error) {
    console.error("Login request failed:", error);
  }
}

function getCustomerAccessTokenFromCookie() {
  const match = document.cookie.match(/(?:^|; )customerAccessToken=([^;]*)/);

  return match ? decodeURIComponent(match[1]) : null;
}

async function initCustomerChangeForm() {
  const selectors = {
    container: ".js-account",
    changeForm: ".js-customer-change-form",
    changeFormSubmitButton: ".js-customer-change-form-submit-button",
    confirmEmailText: ".js-confirm-email-text",
    otpForm: ".js-otp-form",
    otpInput: ".js-otp-input",
    resendCodeButton: ".js-resend-code-button",
    otpFormSuccess: ".js-otp-form-success",
    otpFormError: ".js-otp-form-error",
    submitButtonLoader: ".loader",
    otpConfirmation: ".js-otp-confirmation",
    otpConfirmationSuccess: ".js-otp-confirmation-success",
    loader: ".loader"
  };

  const classes = {
    loading: "loading",
    success: "success-email-change",
    hide: "hidden"
  };

  const container = document.querySelector(selectors.container);

  if (!container) return;

  const form = document.querySelector(selectors.changeForm);

  if (!form) return;

  const changeEmailModal = document.querySelector("#PopupCustomerEmailChange");
  const state = {
    pendingCustomerUpdate: null,
    pendingEmail: null,
    otpEventsBound: false,
    modalClickBound: false,
    isResendingOtp: false
  };

  const initialValues = {};
  form.querySelectorAll("input").forEach(input => {
    initialValues[input.name] = input.value.trim();
  });

  await createCustomerAccessToken();

  form.addEventListener("submit", submitFormHandler);

  function resetErrorMessage(messageEl) {
    if (!messageEl) return;

    messageEl.classList.add(classes.hide);
    messageEl.innerHTML = "";
    messageEl.classList.remove("is-invalid");
  }

  function showErrorMessage(messageEl, data, markInvalid = true) {
    if (!messageEl) return;

    messageEl.innerHTML = "";

    if (Array.isArray(data?.errors) && data.errors.length > 0) {
      data.errors.forEach(err => {
        const p = document.createElement("p");
        p.textContent = err.message;
        messageEl.appendChild(p);
      });
    } else if (data?.message) {
      messageEl.textContent = data.message;
    }

    messageEl.classList.remove(classes.hide);

    if (markInvalid) {
      messageEl.classList.add("is-invalid");
    }
  }

  async function requestWithRefresh(makeRequest) {
    let response = await makeRequest(window.customerAuth?.getAccessToken?.());

    if (response?.status === 403) {
      const newToken = await window.customerAuth?.refreshAccessToken?.();

      if (newToken) {
        response = await makeRequest(newToken);
      }
    }

    return response;
  }

  async function submitOtpForm(event, changedEmail, otpFormError) {
    event.preventDefault();

    const otpForm = event.target;

    if (!otpForm) return null;

    const inputs = otpForm.querySelectorAll(selectors.otpInput);
    const otpCode = [...inputs].map((input) => input.value.trim()).join("");

    try {
      otpForm.classList.add(classes.loading);

      await verifyOtp(otpCode, changedEmail, otpFormError);
    } catch (error) {
      console.error("OTP confirmation error:", error);
    } finally {
      otpForm.classList.remove(classes.loading);
    }
  }

  async function verifyOtpAJAX(changedEmail, otpCode, token = window.customerAuth?.getAccessToken?.()) {
    try {
      return await fetch(`${window.GD_API_BASE}/user-profile/email-change/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          "new_email": changedEmail,
          "otp": otpCode
        })
      });
    } catch(error) {
      console.error("Error while verify otp code:", error);
      return null;
    }
  }

  async function verifyOtp(otpCode, changedEmail, otpFormError) {
    resetErrorMessage(otpFormError);

    try {
      let response = await verifyOtpAJAX(changedEmail, otpCode);

      if (response?.status === 403) {
        const newToken = await window.customerAuth?.refreshAccessToken?.();

        if (newToken) {
          response = await verifyOtpAJAX(changedEmail, otpCode, newToken);
        }
      }

      if (!response) {
        showErrorMessage(otpFormError, "Error: verification failed.", false);
        return;
      }

      const data = await response.json();

      if (!response.ok || data.success === false) {
        showErrorMessage(otpFormError, data, false);
      } else {
        const updatePayload = state.pendingCustomerUpdate?.customerInput || { email: changedEmail };
        const updateMessage = state.pendingCustomerUpdate?.formMessage || null;
        const updateResult = await updateCustomer(updatePayload, updateMessage);

        if (!updateResult?.success) {
          showErrorMessage(otpFormError, updateResult?.errorMessage || "Error: profile update failed.", false);
          return;
        }

        const otpConfirmation = document.querySelector(selectors.otpConfirmation);
        const otpConfirmationSuccess = document.querySelector(selectors.otpConfirmationSuccess);

        if (!otpConfirmationSuccess || !otpConfirmation) return;

        if (changeEmailModal && !state.modalClickBound) {
          changeEmailModal.addEventListener("click", (event) => {
            const target = event.target;

            if (!target.closest(".account__content-form-popup-container")) {
              event.stopImmediatePropagation();
            }
          }, true);

          state.modalClickBound = true;
        }

        otpConfirmation.classList.add(classes.hide);
        otpConfirmationSuccess.classList.remove(classes.hide);
        state.pendingCustomerUpdate = null;
      }
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  }

  async function sendOtpAJAX(changedEmail, token = window.customerAuth?.getAccessToken?.()) {
    try {
      return await fetch(`${window.GD_API_BASE}/user-profile/email-change/send-otp?source=shopify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ new_email: changedEmail })
      });
    } catch(error) {
      console.error("Error while send otp code:", error);
      return null;
    }
  }

  async function sendOtp(changedEmail, formError) {
    resetErrorMessage(formError);

    try {
      const response = await requestWithRefresh((token) => sendOtpAJAX(changedEmail, token));

      if (!response) {
        showErrorMessage(formError, "Error: OTP request failed.");
        return { success: false, status: 0 };
      }

      const data = await response.json();

      if (!response.ok || data.success === false) {
        showErrorMessage(formError, data);
      }

      return {
        "success": response.ok,
        "status": response.status
      };
    } catch(error) {
      console.error("Unexpected error:", error);
    }
  }

  async function submitFormHandler(event) {
    event.preventDefault();

    const changeForm = event.target;

    if (!changeForm) return;

    const formMessage = document.getElementById('form-message');
    const formData = new FormData(changeForm);
    const changedFields = [];

    formData.forEach((value, key) => {
      const trimmedValue = value.trim();
      if (trimmedValue !== (initialValues[key] || "")) {
        changedFields.push(key);
      }
    });

    const customerInput = {
      firstName: formData.get('first_name'),
      lastName: formData.get('last_name'),
      email: formData.get('email')
    };

    const phoneValue = formData.get('phone')?.trim();
    if (phoneValue) {
      customerInput.phone = phoneValue;
    } else {
      customerInput.phone = null;
    }

    const changedEmail = formData.get('email');

    if (changedFields.includes("email") && changedEmail) {
      state.pendingCustomerUpdate = { customerInput, formMessage };
      state.pendingEmail = changedEmail;
      const confirmEmailText = changeEmailModal?.querySelector(selectors.confirmEmailText);
      const otpForm = changeEmailModal?.querySelector(selectors.otpForm);
      const otpFormSuccess = changeEmailModal?.querySelector(selectors.otpFormSuccess);
      const otpFormError = changeEmailModal?.querySelector(selectors.otpFormError);
      const resendCodeButton = changeEmailModal?.querySelector(selectors.resendCodeButton);
      const submitButton = changeForm.querySelector(selectors.changeFormSubmitButton);
      const submitButtonLoader = submitButton?.querySelector(selectors.submitButtonLoader);

      try {
        submitButton?.classList.add(classes.loading);
        submitButtonLoader?.classList.remove("is-hidden");

        const sendOtpData = await sendOtp(changedEmail, formMessage);

        if (sendOtpData.success) {
          if (otpForm) {
            window.initOtpInputs?.(otpForm, selectors.otpInput);
            if (!state.otpEventsBound) {
              otpForm.addEventListener("submit", (event) => submitOtpForm(event, state.pendingEmail, otpFormError));

              resendCodeButton?.addEventListener("click", async () => {
                const buttonLoader = resendCodeButton.querySelector(selectors.loader);

                if (state.isResendingOtp) return;

                state.isResendingOtp = true;
                resendCodeButton.classList.add(classes.loading);
                buttonLoader?.classList.remove(classes.hide);
                otpFormSuccess?.classList.add(classes.hide);

                try {
                  const resendOtpData = await sendOtp(state.pendingEmail, otpFormError);

                  if (resendOtpData?.success) {
                    otpFormSuccess?.classList.remove(classes.hide);
                  }
                } finally {
                  state.isResendingOtp = false;
                  resendCodeButton.classList.remove(classes.loading);
                  buttonLoader?.classList.add(classes.hide);
                }
              });

              state.otpEventsBound = true;
            }
          }

          if (confirmEmailText) confirmEmailText.innerText = changedEmail;

          changeEmailModal?.show();
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        submitButton?.classList.remove(classes.loading);
        submitButtonLoader?.classList.add("is-hidden");
      }

      return;
    }

    await updateCustomer(customerInput, formMessage);
  }

  async function updateCustomer(customerInput, formMessage) {
    const customerAccessToken = getCustomerAccessTokenFromCookie();

    const variables = {
      customerAccessToken: customerAccessToken,
      customer: customerInput
    };

    const query = `
      mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
        customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
          customer {
            firstName
            lastName
            email
            phone
          }
          customerUserErrors {
            code
            message
            field
          }
        }
      }
    `;

    try {
      if (formMessage) {
        formMessage.textContent = "Updating...";
      }

      const response = await fetch(`https://${window.SHOPIFY_DOMAIN}/api/2025-01/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": window.STOREFRONT_ACCESS_TOKEN
        },
        body: JSON.stringify({ query, variables })
      });

      const result = await response.json();
      const updateData = result.data?.customerUpdate;

      if (!updateData) {
        const errorMessage = "Error: " + (result.errors?.[0]?.message || "Unknown error");

        if (formMessage) {
          formMessage.textContent = errorMessage;
          formMessage.classList.add("is-invalid");
        }
        return { success: false, errorMessage };
      }

      if (updateData.customerUserErrors.length > 0) {
        const errorMessage = "Error: " + updateData.customerUserErrors.map(e => e.message).join(", ");
        if (formMessage) {
          formMessage.textContent = errorMessage;
          formMessage.classList.add("is-invalid");
        }
        return { success: false, errorMessage };
      }

      if (formMessage) {
        formMessage.textContent = "Profile updated successfully!";

        if (formMessage.classList.contains("is-invalid")) {
          formMessage.classList.remove("is-invalid");
        }

        formMessage.classList.add("is-valid");
      }

      return { success: true };
    } catch (error) {
      const errorMessage = "Request failed: " + error.message;
      if (formMessage) {
        formMessage.textContent = errorMessage;
        formMessage.classList.add("is-invalid");
      }
      return { success: false, errorMessage };
    }
  }
}

initCustomerChangeForm();

function setJWTTokensFromMobileApp() {
  const JWT_PARAM_KEYS = ["customerBackendToken", "customerBackendRefreshToken"];

  const url = new URL(window.location.href);
  let hasTokenParams = false;

  for (const key of JWT_PARAM_KEYS) {
    const value = url.searchParams.get(key);

    if (value) {
      window.setCookie(key, value);

      url.searchParams.delete(key);
      hasTokenParams = true;
    }
  }

  if (!hasTokenParams) return;

  window.history.replaceState(null, "", url.toString());
}

setJWTTokensFromMobileApp();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    if (!event.currentTarget.closest('details').hasAttribute('open')) {
      document.body.classList.add(`overflow-hidden-${summary.dataset.breakpoint}`);
    } else {
      document.body.classList.remove(`overflow-hidden-${summary.dataset.breakpoint}`);
    }

    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function formatMoney(cents, format = "${{amount}}") {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsPart = parts[1] ? (decimal + parts[1]) : '';
    return dollars + centsPart;
  }

  switch (format.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    // GAH-EU-LP-01: Sweden's market format. Unknown placeholders printed "kr" with no number
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, '\u00a0', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, '\u00a0', ',');
      break;
  }

  return format.replace(placeholderRegex, value);
}

function getMoneyNoDecimalsFormat() {
  const fmt = window.money_no_decimals_format;
  if (fmt) {
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (m && ['amount_no_decimals', 'amount_no_decimals_with_comma_separator', 'amount_no_decimals_with_space_separator'].includes(m[1])) return fmt;
  }
  if (window.money_format) {
    return window.money_format
      .replace('{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}')
      .replace('{{amount_with_space_separator}}', '{{amount_no_decimals_with_space_separator}}')
      .replace('{{amount}}', '{{amount_no_decimals}}');
  }
  return '${{amount_no_decimals}}';
}

function getMoneyDecimalsFormat() {
  const fmt = window.money_format_decimals || window.money_format;
  if (!fmt) return '${{amount}}';
  return fmt
    .replace('{{amount_no_decimals_with_comma_separator}}', '{{amount_with_comma_separator}}')
    .replace('{{amount_no_decimals_with_space_separator}}', '{{amount_with_space_separator}}')
    .replace('{{amount_no_decimals}}', '{{amount}}');
}

function formatMoneyWithoutTrailingZeros(cents) {
  var hasFraction = Math.abs(cents % 100) !== 0;
  var fmt = hasFraction
    ? (typeof getMoneyDecimalsFormat === 'function' ? getMoneyDecimalsFormat() : '${{amount}}')
    : (typeof getMoneyNoDecimalsFormat === 'function' ? getMoneyNoDecimalsFormat() : '${{amount_no_decimals}}');
  return formatMoney(cents, fmt);
}

// Liquid's money_without_trailing_zeros. Under a no-decimals shop format
// ("${{amount_no_decimals}}") Liquid ROUNDS, so a $285.25 total prints $285;
// formatMoneyWithoutTrailingZeros would print $285.25 there. Everything that
// has to read exactly like a server-rendered price uses this one.
function formatMoneyLiquidNoZeros(cents) {
  const format = window.money_format || '';
  if (/\{\{\s*amount_no_decimals/.test(format)) return formatMoney(cents, format);
  return formatMoneyWithoutTrailingZeros(cents);
}

function parseFormDataItems(formData) {
  const items = {};

  for (const [key, value] of formData.entries()) {
    let index, name, propertyKey;
    const indexedMatch = key.match(/^items\[(\d+)\]\[(\w+)\](?:\[([^\]]+)\])?$/);
    const flatMatch = key.match(/^(\w+)(?:\[([^\]]+)\])?$/);

    if (indexedMatch) {
      index = indexedMatch[1];
      name = indexedMatch[2];
      propertyKey = indexedMatch[3];
    } else if (flatMatch) {
      index = '0';
      name = flatMatch[1];
      propertyKey = flatMatch[2];
    } else {
      continue;
    }

    if (!items[index]) {
      items[index] = {
        variant_id: null,
        selling_plan: null,
        quantity: 1,
        properties: {}
      }
    }

    switch (name) {
      case 'id':
        items[index].variant_id = parseInt(value, 10) || null;
        break;
      case 'selling_plan':
        items[index].selling_plan = parseInt(value, 10) || null;
        break;
      case 'quantity':
        items[index].quantity = parseInt(value, 10) || 1;
        break;
      case 'properties':
        if (propertyKey) {
          items[index].properties[propertyKey] = value;
        } 
        break;
    }
  }

  return Object.values(items).filter(item => item.variant_id);
}

function getExistingCartItem(item) {
  if (!item) {
    return null;
  }

  const cartItems = window._cartState ? window._cartState.items : [];

  if (!cartItems.length) {
    return null;
  }

  return cartItems.find(cartItem => {
    const itemVariantId = item.variant_id;
    const cartItemVariantId = cartItem.variant_id;

    if (itemVariantId !== cartItemVariantId) {
      return false;
    }

    const itemSellingPlanId = item?.selling_plan ?? null;
    const cartSellingPlanId = cartItem?.selling_plan_allocation?.selling_plan?.id ?? null;

    if (itemSellingPlanId !== cartSellingPlanId) {
      return false;
    }

    const itemProperties = item?.properties ?? {};
    const cartItemProperties = cartItem?.properties ?? {};

    const itemKeys = Object.keys(itemProperties);
    const cartItemKeys = Object.keys(cartItemProperties);

    if (itemKeys.length !== cartItemKeys.length) {
      return false;
    }

    return itemKeys.every(key => itemProperties[key] === cartItemProperties[key]);
  });
}

function getFormItem(item, formItems) {
  if(!formItems || !formItems.length || !item || !item.variantId) {
    return null;
  }

  return formItems.find(formItem => formItem.variant_id === parseInt(item.variantId, 10));
}

/* ------------------------------------------------------------------ */
/*  CartOptimist — single owner of all optimistic cart display state   */
/* ------------------------------------------------------------------ */
// Bumped by every CartOptimist mutation. A /cart.js read that started before the bump is a
// pre-mutation snapshot, so reconciling it would undo the change the user just made.
window._CART_OPTIMISTIC_SEQ = 0;
(function () {
  var _productTotal = 0;
  let _protectableTotal = 0;
  var _compareTotal = 0;
  var _count = 0;
  var _spOverride = null;
  // What the server's total carries beyond products + protection: cart-level
  // discounts, measured from the last full cart (total_price minus both).
  // Keeping it means an optimistic total never drops a discount code.
  let _offset = 0;
  // The redesign footer's SAVE pill amount (null until a cart is known)
  let _savings = null;
  // Quantities already previewed per line (by key), against window._cartState.
  // A stepper tap previews on its own frame and the debounced request previews
  // the same number again, so every step is applied relative to the last
  // preview, never to the server line - two calls with one quantity change the
  // totals once. A full server cart clears it (_fromCart).
  let _qtyPreviewed = {};

  function _isSpEnabled() {
    if (_spOverride !== null) return _spOverride;
    var sp = window.ShippingProtection;
    return sp && typeof sp.isEnabled === 'function' && sp.isEnabled();
  }

  // The price of the protection line the cart WILL hold: the formula's target
  // snapped to a real variant exactly as ShippingProtection.syncCart snaps it.
  // The raw formula is whole dollars, the variant table is not (a $255 cart
  // targets $8 and is charged $8.25), so totals built on the formula drifted.
  function _spCents(pt) {
    if (!_isSpEnabled() || pt <= 0) return 0;
    var sp = window.ShippingProtection;
    if (!sp || typeof sp.computeProtectionCents !== 'function') return 0;
    var target = sp.computeProtectionCents(pt);
    var variant = typeof sp.findBestVariant === 'function' ? sp.findBestVariant(target) : null;
    return variant ? variant.price : target;
  }

  function _spLineCents(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      return (item.handle || '').includes('shipping-protection') ? sum + (item.final_line_price || 0) : sum;
    }, 0);
  }

  // SAVE pill amount for a full cart, the way cart-drawer.liquid sums it:
  // compare-at x qty minus the line price, over non-service lines whose
  // variant compare-at beats its price. Line compare-at is not in the Ajax
  // cart, so it comes from the instant-cart catalog; any line it does not know
  // leaves the server-rendered pill as the source.
  function _savingsForCart(cart) {
    var ic = window.InstantCart;
    if (!ic || typeof ic.variant !== 'function' || !cart || !cart.items) return null;
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var handle = item.handle || '';
      var props = item.properties || {};
      if (handle.includes('shipping-protection') || handle.includes('navidium') || props['_gwp-product'] || props._cart_promo_item) continue;
      const coachCompare = _bundleCoachCompare(item);
      if (coachCompare) {
        total += Math.max(0, coachCompare * item.quantity - (item.final_line_price || 0));
        continue;
      }
      var info = ic.variant(item.variant_id);
      if (!info) return null;
      if (info.c > info.p) total += info.c * item.quantity - (item.final_line_price || 0);
    }
    return total;
  }

  // GAH-SAVE-PILL: the coaching line of a three-line bundle group has no
  // compare-at of its own, so the pill missed its share of the bundle's struck
  // price (x2 read "$796" struck beside "SAVE $382"). It is worth what the
  // bundle's compare-at leaves after the mat and pad (GD_SUB.coachValue).
  function _bundleCoachCompare(item) {
    const props = (item && item.properties) || {};
    if (!props._bm_bundle || props._bm_bundle_role === 'main' || String(props._bm_bundle_order) !== '2') return 0;
    const value = window.GD_SUB && window.GD_SUB.coachValue;
    return value > 0 ? value : 0;
  }

  // the upgrade card and the protection slot follow the cart on screen
  function _syncRegions(items) {
    var ic = window.InstantCart;
    if (ic && typeof ic.syncRegions === 'function') {
      try { ic.syncRegions(items); } catch (e) {}
    }
  }

  function _readSavingsFromDOM() {
    var was = document.querySelector('cart-drawer .js-cart-was[data-savings-cents]');
    if (was) return Math.max(0, parseInt(was.dataset.savingsCents, 10) || 0);
    var el = document.querySelector('.js-cart-drawer-savings-badge');
    return el ? Math.max(0, _parseMoneyToCents(el.textContent)) : 0;
  }

  // a single line's share of the SAVE pill, from the catalog or its own row
  function _lineSavings(item, quantity) {
    if (!item) return 0;
    var handle = item.handle || '';
    var props = item.properties || {};
    if (handle.includes('shipping-protection') || handle.includes('navidium') || props['_gwp-product'] || props._cart_promo_item) return 0;
    const coachCompare = _bundleCoachCompare(item);
    if (coachCompare) return Math.max(0, (coachCompare - (item.final_price || 0)) * quantity);
    var ic = window.InstantCart;
    var info = ic && typeof ic.variant === 'function' ? ic.variant(item.variant_id) : null;
    var unit = item.final_price || item.price || 0;
    if (info) return info.c > info.p ? info.c * quantity - unit * quantity : 0;
    // a line the catalog does not know: its own row prints the unit compare-at
    var compare = _rowUnitCompare(item);
    return compare > unit ? (compare - unit) * quantity : 0;
  }

  // the unit compare-at the server printed on a line's drawer row: the struck
  // price beside the unit price, or the bundle card's struck line total / qty
  function _rowUnitCompare(item) {
    if (!item || !item.key || typeof CSS === 'undefined') return 0;
    var row = document.querySelector('cart-drawer .cart-item[data-item-key="' + CSS.escape(item.key) + '"]');
    if (!row) return 0;
    var struck = row.querySelector('.cart-item__old-price.igComparePrice');
    if (struck) return _parseMoneyToCents(struck.textContent);
    var was = row.querySelector('.cart-item__bmb-was');
    if (was && item.quantity) return Math.round(_parseMoneyToCents(was.textContent) / item.quantity);
    return 0;
  }

  function _computeProtectableTotal(cart) {
    if (!cart || !cart.items) return 0;
    const sp = window.ShippingProtection;
    if (sp && typeof sp.getProtectableProductTotal === 'function') {
      return sp.getProtectableProductTotal(cart);
    }
    let hasPhysical = false;
    let subtotal = 0;
    cart.items.forEach(function (item) {
      const handle = item.handle || '';
      if (handle.includes('shipping-protection')) return;
      subtotal += item.final_line_price || item.line_price || 0;
      // a bundle line ships through its components (see shipping-protection.js)
      if (item.requires_shipping === true || item.has_components === true) hasPhysical = true;
    });
    return hasPhysical ? subtotal : 0;
  }

  function _computeCompareTotal(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items
      .filter(function (i) {
        var isShippingProtection = i && i.handle && (i.handle.includes('shipping-protection') || i.handle.includes('navidium'));
        var isGwp = i && i.properties && i.properties['_gwp-product'] === 'true';
        return !isShippingProtection && !isGwp;
      })
      .reduce(function (s, i) {
        var up = i.final_price || i.price;
        if (i.compare_at_price && i.compare_at_price > up) {
          return s + (i.compare_at_price * i.quantity);
        }
        return s;
      }, 0);
  }

  function _parseMoneyToCents(text) {
    if (!text) return 0;
    var cleaned = String(text).replace(/\s/g, '').replace(/[^0-9,.-]/g, '');
    if (!cleaned) return 0;

    var negative = cleaned.indexOf('-') !== -1;
    cleaned = cleaned.replace(/-/g, '');

    var comma = cleaned.lastIndexOf(',');
    var dot = cleaned.lastIndexOf('.');
    var decimalSep = null;

    if (comma !== -1 && dot !== -1) {
      decimalSep = comma > dot ? ',' : '.';
    } else if (comma !== -1) {
      var commaDigits = cleaned.length - comma - 1;
      if (commaDigits > 0 && commaDigits <= 2) decimalSep = ',';
    } else if (dot !== -1) {
      var dotDigits = cleaned.length - dot - 1;
      if (dotDigits > 0 && dotDigits <= 2) decimalSep = '.';
    }

    var normalized = cleaned;
    if (decimalSep) {
      var thousandSep = decimalSep === ',' ? '.' : ',';
      normalized = normalized.replace(new RegExp('\\' + thousandSep, 'g'), '');
      normalized = normalized.replace(decimalSep, '.');
    } else {
      normalized = normalized.replace(/[.,]/g, '');
    }

    var parsed = parseFloat(normalized);
    if (isNaN(parsed)) return 0;
    var cents = Math.round(parsed * 100);
    return negative ? -cents : cents;
  }

  function _extractCompareFromSections(cart) {
    if (!cart || !cart.sections) return null;
    var html = cart.sections['cart-drawer'];
    if (!html) {
      for (var k in cart.sections) {
        if (cart.sections[k] && typeof cart.sections[k] === 'string' && cart.sections[k].indexOf('totals__old-price') !== -1) {
          html = cart.sections[k];
          break;
        }
      }
    }
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector('.totals__old-price');
    if (!el || !el.textContent.trim()) return 0;
    return _parseMoneyToCents(el.textContent);
  }

  function _readCompareFromDOM() {
    var el = document.querySelector('.totals__old-price');
    if (!el || !el.textContent.trim() || el.style.display === 'none') return null;
    return _parseMoneyToCents(el.textContent);
  }

  // serverFooter: the footer on screen was just swapped in from the server's
  // render, so its SAVE pill is the truth - never recompute it from a catalog
  // that may be minutes old
  function _fromCart(cart, serverFooter) {
    // /cart/add.js with a multi-item payload returns `{ items: [<added items>], sections }`
    // — the `items` array is the added items, NOT the full cart, and cart-level fields
    // like `items_subtotal_price` are absent. Reading count/totals from that shape would
    // clobber the optimistic state with a partial view (e.g. counting only the just-added
    // gift line and flashing the drawer empty). Only treat the response as authoritative
    // when it carries a cart-level field.
    var hasFullCart = !!(cart && Array.isArray(cart.items) && cart.items_subtotal_price !== undefined);
    if (hasFullCart) {
      _qtyPreviewed = {};
      _productTotal = (typeof getProductOnlyTotal === 'function') ? getProductOnlyTotal(cart) : 0;
      _protectableTotal = _computeProtectableTotal(cart);
      _count = (typeof getRealItemCount === 'function') ? getRealItemCount(cart) : 0;
      if (typeof cart.total_price === 'number') {
        _offset = cart.total_price - _productTotal - _spLineCents(cart);
      }
      var computedSavings = serverFooter ? null : _savingsForCart(cart);
      _savings = computedSavings !== null ? computedSavings : _readSavingsFromDOM();
    }
    _spOverride = null;

    var sectionCmp = _extractCompareFromSections(cart);
    if (sectionCmp !== null) {
      _compareTotal = sectionCmp;
      return;
    }

    var domCmp = _readCompareFromDOM();
    if (domCmp !== null && domCmp > _productTotal) {
      _compareTotal = domCmp;
      return;
    }

    if (hasFullCart) {
      var computed = _computeCompareTotal(cart);
      if (computed > _productTotal) {
        _compareTotal = computed;
      }
    }
  }

  function _render() {
    const spc = _spCents(_protectableTotal);
    const display = Math.max(0, _productTotal + spc + _offset);

    /* GAH-SPX-01: the drawer total carries both arms' figures (cart-drawer.liquid)
       and html.gd-spx shows one. Arm B's Subtotal is the same total less the
       protection line, so a toggle, a discount or a tier swap moves both
       alike. A total with no pair (/cart) keeps the one figure. */
    const displayExcl = Math.max(0, display - spc);
    document.querySelectorAll('.js-cart-drawer-subtotal, .totals__subtotal-value')
      .forEach(function (el) {
        const incl = el.querySelector('.js-spx-incl');
        const excl = el.querySelector('.js-spx-excl');
        if (!incl && !excl) {
          el.textContent = formatMoneyLiquidNoZeros(display);
          return;
        }
        if (incl) incl.textContent = formatMoneyLiquidNoZeros(display);
        if (excl) excl.textContent = formatMoneyLiquidNoZeros(displayExcl);
      });

    _renderSavingsPill(displayExcl);
    _queueSavingsAttribute();

    var cmpEls = document.querySelectorAll('.totals__old-price');
    var badgeEls = document.querySelectorAll('.totals .badge.price__badge-sale');
    if (_compareTotal && _compareTotal > display) {
      if (!cmpEls.length) {
        document.querySelectorAll('.totals__discounted-prices').forEach(function (dp) {
          if (!dp.querySelector('.totals__old-price')) {
            dp.insertAdjacentHTML('beforeend', '<s class="totals__old-price totals__price"></s>');
          }
        });
        cmpEls = document.querySelectorAll('.totals__old-price');
      }
      cmpEls.forEach(function (el) {
        el.textContent = formatMoneyWithoutTrailingZeros(_compareTotal);
        el.style.display = '';
      });
      var pct = Math.round(((_compareTotal - display) / _compareTotal) * 100);
      badgeEls.forEach(function (el) {
        var savingsSuffix = (window.cartStrings && window.cartStrings.savingsBadgeSuffix) || 'OFF';
        el.textContent = pct + '% ' + savingsSuffix;
        el.style.display = '';
      });
    } else {
      cmpEls.forEach(function (el) { el.style.display = 'none'; });
      badgeEls.forEach(function (el) { el.style.display = 'none'; });
    }

    document.querySelectorAll('.js-cart-count-bubble')
      .forEach(function (el) { el.textContent = _count; });
    document.querySelectorAll('.js-cart-count-bubble-text')
      .forEach(function (el) { el.textContent = el.textContent.replace(/\d+/, _count); });

    // Optimistic empty-state toggle: _count excludes ignored items (gift, shipping protection, etc.),
    // so when it hits 0 the drawer should show the empty UI immediately — without waiting for the
    // server reconcile to flip the classes.
    var isEmpty = _count <= 0;
    document.querySelectorAll('cart-drawer, cart-drawer-items, #main-cart-footer')
      .forEach(function (el) { el.classList.toggle('is-empty', isEmpty); });

    // the widget label follows the same protectable total as Total, not the
    // pre-change window._cartState updateWidgetPrice reads
    var sp = window.ShippingProtection;
    if (sp && typeof sp.protectionPriceText === 'function') {
      var spText = sp.protectionPriceText(_protectableTotal);
      document.querySelectorAll('.js-sp-price').forEach(function (el) { el.textContent = spText; });
    } else if (sp && typeof sp.updateWidgetPrice === 'function') {
      sp.updateWidgetPrice(_productTotal);
    }
  }

  // The redesign footer's "SAVE $X" pill (cart-drawer.liquid, inside
  // .totals__price-group). Nothing wrote it before, so it appeared, vanished
  // or went stale only when the server answered. Same translation string and
  // the same money filter output as the Liquid, created, updated or removed
  // in place so the Total beside it never moves at swap time.
  function _renderSavingsPill(subtotalCents) {
    if (_savings === null) return;
    /* GAH-CART-SAVED: the struck "was" figure and the "% SAVED" badge, both
       measured against the Subtotal without protection */
    const save = _savings > 0 ? _savings : 0;
    const was = (subtotalCents || 0) + save;
    document.querySelectorAll('cart-drawer .js-cart-was').forEach(function (el) {
      el.hidden = !save;
      el.dataset.savingsCents = String(save);
      if (save) el.textContent = formatMoneyLiquidNoZeros(was);
    });
    document.querySelectorAll('cart-drawer .js-cart-saved-pct').forEach(function (el) {
      el.hidden = !save || !was;
      if (save && was) el.textContent = Math.round((save * 100) / was) + '% SAVED';
    });
    // GAH-SAVE-01: arm B's twin of the badge, the same saving in dollars
    // (snippets/save-flags; the head gate shows one of the pair)
    document.querySelectorAll('cart-drawer .js-cart-saved-usd').forEach(function (el) {
      el.hidden = !save;
      if (save) el.textContent = formatMoneyLiquidNoZeros(save) + ' SAVED';
    });
    const template = (window.cartStrings && window.cartStrings.cartSaveAmountTemplate) || '';
    document.querySelectorAll('cart-drawer .totals__price-group').forEach(function (group) {
      let pill = group.querySelector('.js-cart-drawer-savings-badge');
      if (_savings <= 0 || !template) {
        if (pill && _savings <= 0) pill.remove();
        return;
      }
      if (!pill) {
        pill = document.createElement('span');
        pill.className = 'totals__savings-badge js-cart-drawer-savings-badge';
        pill.dataset.spx = 'a';
        group.appendChild(pill);
      }
      const text = template.replace('[amount]', formatMoneyLiquidNoZeros(_savings));
      if (pill.textContent.trim() !== text) pill.textContent = text;
    });
  }

  /* Checkout "Total savings" (Paul, 2026-10-06). Shopify's checkout prints a
     savings row only for discounts, never for compare-at prices, so the SAVE
     pill's figure rides to checkout as the cart attribute _gd_savings - a
     decimal in the cart's currency, '' when there is nothing saved - and a
     Checkout Blocks dynamic block prints it under the total. Written only
     when it differs from the cart's, a moment after the drawer settles (never
     mid-add), as a follow-up write a Check out tap waits for. Read back 1.5s
     later, or by the tap if it comes first, and repeated once if it did not
     stick: Intelligems reads the cart around theme writes, and a write inside
     one of those reads can be acknowledged and then lost. Only a page that
     drew the drawer footer writes it, so a page that cannot know the figure
     never clears it. */
  const SAVINGS_ATTR = '_gd_savings';
  let _savingsTimer = null;
  // a Check out tap while a write is queued runs it at once (InstantCart.beforeCheckout)
  let _savingsFlushOff = null;

  function _savingsAttrWanted() {
    return _savings !== null && _savings > 0 && _count > 0 ? (_savings / 100).toFixed(2) : '';
  }

  function _savingsAttrOf(cart) {
    const have = cart && cart.attributes ? cart.attributes[SAVINGS_ATTR] : null;
    return have == null ? '' : String(have);
  }

  function _postSavingsAttr(value) {
    const attributes = {};
    attributes[SAVINGS_ATTR] = value;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) {
      return r.ok ? r.json() : null;
    }).then(function (cart) {
      // attributes only: the rest of this answer may predate an optimistic change
      if (cart && cart.attributes && window._cartState) window._cartState.attributes = cart.attributes;
      return cart;
    }).catch(function () { return null; });
  }

  // write the current figure if the cart's differs, then read it back once and
  // repeat if it did not stick; resolves when done (never rejects)
  function _writeSavingsAttr(fromTap) {
    _savingsTimer = null;
    if (_savingsFlushOff) { _savingsFlushOff(); _savingsFlushOff = null; }
    if (!document.querySelector('cart-drawer .totals__price-group')) return Promise.resolve();
    // a held tap has already waited for every cart write; a timer just tries later
    if (!fromTap && window._CART_ADD_IN_PROGRESS) {
      _queueSavingsAttribute();
      return Promise.resolve();
    }
    const want = _savingsAttrWanted();
    if (want === _savingsAttrOf(window._cartState)) return Promise.resolve();
    const ic = window.InstantCart;
    const write = _postSavingsAttr(want);
    if (!fromTap && ic && typeof ic.hold === 'function') ic.hold(write, { followUp: true });
    const check = write
      .then(function () { return new Promise(function (r) { setTimeout(r, fromTap ? 0 : 1500); }); })
      .then(function () { return fetch('/cart.js', { cache: 'no-store' }); })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (fresh) {
        // a newer figure has its own write on the way; leave this one
        if (!fresh || _savingsAttrWanted() !== want) return null;
        if (_savingsAttrOf(fresh) !== want) return _postSavingsAttr(want);
        return null;
      })
      .catch(function () { return null; });
    return check;
  }

  function _queueSavingsAttribute() {
    if (_savings === null) return;
    if (_savingsTimer) clearTimeout(_savingsTimer);
    _savingsTimer = setTimeout(function () { _writeSavingsAttr(false); }, 800);
    const ic = window.InstantCart;
    if (!_savingsFlushOff && ic && typeof ic.beforeCheckout === 'function') {
      _savingsFlushOff = ic.beforeCheckout(function () {
        if (_savingsTimer) clearTimeout(_savingsTimer);
        _savingsFlushOff = null;
        return _writeSavingsAttr(true);
      });
    }
  }


  function _dispatchOptimisticProgress() {
    const spc = _spCents(_protectableTotal);
    const display = _productTotal + spc + _offset;
    document.dispatchEvent(new CustomEvent('cart:optimistic-subtotal', {
      detail: { subtotalCents: display },
    }));
  }

  function optimisticAdd(priceCents, compareAtCents, gwpCount) {
    window._CART_OPTIMISTIC_SEQ++;
    const cart = window._cartState;
    const base = (typeof getProductOnlyTotal === 'function' && cart) ? getProductOnlyTotal(cart) : _productTotal;
    const baseProtectable = cart ? _computeProtectableTotal(cart) : _protectableTotal;
    _productTotal = base + (priceCents || 0);
    const hasPhysicalSignal = baseProtectable > 0 || (gwpCount || 0) > 0;
    _protectableTotal = hasPhysicalSignal ? (_productTotal) : baseProtectable;
    var cmpAdd = (compareAtCents && compareAtCents > priceCents) ? compareAtCents : 0;
    _compareTotal = (_compareTotal || 0) + cmpAdd;
    if (_savings !== null && cmpAdd) _savings += cmpAdd - (priceCents || 0);
    var baseCount = (cart && typeof getRealItemCount === 'function') ? getRealItemCount(cart) : _count;
    _count = baseCount + 1 + (gwpCount || 0);
    _render();
    _dispatchOptimisticProgress();
  }

  function _parseDOMPrice(line) {
    var el = document.getElementById('CartDrawer-Item-' + line) || document.getElementById('CartItem-' + line);
    if (!el) return 0;
    var totalsWrap = el.querySelector('.cart-item__price-wrapper');
    var priceEls = totalsWrap ? totalsWrap.querySelectorAll('.price.price--end') : [];
    var priceEl = priceEls.length ? priceEls[priceEls.length - 1] : el.querySelector('.cart-item__price');
    if (!priceEl) return 0;
    return _parseMoneyToCents(priceEl.textContent);
  }

  function optimisticRemove(indexes) {
    window._CART_OPTIMISTIC_SEQ++;
    const cart = window._cartState;
    const base = _productTotal;
    const baseCmp = _compareTotal;
    const baseCount = _count;
    let pRed = 0, cRed = 0, nRed = 0, sRed = 0;
    const removeIdx = {};
    indexes.forEach(function (line) { removeIdx[line - 1] = true; });
    indexes.forEach(function (line) {
      var item = cart && cart.items ? cart.items[line - 1] : null;
      if (item) {
        // Items that aren't part of the visible real-item total (progress gift, shipping
        // protection, subscription bundle stubs) are excluded from `baseCount`, so they
        // must also be skipped here — otherwise atomically removing a gift alongside a
        // real line double-subtracts and pushes _count negative (clamped to 0), making
        // the drawer flash empty even when real items remain.
        if (typeof isIgnoredCartItem === 'function' && isIgnoredCartItem(item)) return;
        // a quantity previewed by the stepper is what is on screen, so remove that
        const key = item.key || String(line);
        const shown = Object.prototype.hasOwnProperty.call(_qtyPreviewed, key) ? _qtyPreviewed[key] : item.quantity;
        const up = item.final_price || item.price;
        pRed += up * shown;
        const cp = item.compare_at_price && item.compare_at_price > up ? item.compare_at_price : 0;
        cRed += cp * shown;
        nRed += shown;
        sRed += _lineSavings(item, shown);
        _qtyPreviewed[key] = 0;
      } else {
        const domPrice = _parseDOMPrice(line);
        pRed += domPrice;
        nRed += 1;
      }
    });
    _productTotal = Math.max(0, base - pRed);
    if (cart && cart.items) {
      const simulated = cart.items
        .filter(function (_item, idx) { return !removeIdx[idx]; })
        .map(function (cartItem) {
          const q = cartItem.key && Object.prototype.hasOwnProperty.call(_qtyPreviewed, cartItem.key) ? _qtyPreviewed[cartItem.key] : cartItem.quantity;
          if (q === cartItem.quantity) return cartItem;
          const unit = cartItem.final_price || cartItem.price || 0;
          return Object.assign({}, cartItem, { quantity: q, line_price: unit * q, final_line_price: unit * q });
        })
        .filter(function (cartItem) { return cartItem.quantity > 0; });
      _protectableTotal = _computeProtectableTotal({ items: simulated });
      _syncRegions(simulated);
    } else {
      _protectableTotal = Math.max(0, _protectableTotal - pRed);
    }
    _compareTotal = Math.max(0, baseCmp - cRed);
    _count = Math.max(0, baseCount - nRed);
    if (_savings !== null) _savings = Math.max(0, _savings - sRed);
    _render();
    _dispatchOptimisticProgress();
  }

  // `key` (the row's line key) wins over the 1-based `line`: a protection line
  // added or removed after a render shifts every index below it, while keys
  // never move
  function optimisticQuantity(line, newQty, key) {
    window._CART_OPTIMISTIC_SEQ++;
    const cart = window._cartState;
    const byKey = key && cart && cart.items ? cart.items.find(function (i) { return i.key === key; }) : null;
    const item = byKey || ((cart && cart.items) ? cart.items[line - 1] : null);

    if (item) {
      const up = item.final_price || item.price;
      const key = item.key || String(line);
      const prevQty = Object.prototype.hasOwnProperty.call(_qtyPreviewed, key) ? _qtyPreviewed[key] : item.quantity;
      const nextQty = Math.max(0, newQty);
      const cp = item.compare_at_price && item.compare_at_price > up ? item.compare_at_price : 0;

      _productTotal = Math.max(0, _productTotal + up * (nextQty - prevQty));
      _compareTotal = Math.max(0, _compareTotal + cp * (nextQty - prevQty));
      if (!(typeof isIgnoredCartItem === 'function' && isIgnoredCartItem(item))) {
        _count = Math.max(0, _count + (nextQty - prevQty));
      }
      if (_savings !== null) {
        _savings = Math.max(0, _savings + _lineSavings(item, nextQty) - _lineSavings(item, prevQty));
      }
      _qtyPreviewed[key] = nextQty;

      const simulated = cart.items.reduce(function (acc, cartItem) {
        const k = cartItem.key;
        const q = k && Object.prototype.hasOwnProperty.call(_qtyPreviewed, k) ? _qtyPreviewed[k] : cartItem.quantity;
        if (q <= 0) return acc;
        if (q === cartItem.quantity) {
          acc.push(cartItem);
          return acc;
        }
        const cloned = Object.assign({}, cartItem);
        cloned.quantity = q;
        cloned.line_price = (cartItem.final_price || cartItem.price || 0) * q;
        cloned.final_line_price = cloned.line_price;
        acc.push(cloned);
        return acc;
      }, []);
      _protectableTotal = _computeProtectableTotal({ items: simulated });
      _syncRegions(simulated);
    } else {
      if (newQty === 0) {
        const domPrice = _parseDOMPrice(line);
        _productTotal = Math.max(0, _productTotal - domPrice);
        _protectableTotal = Math.max(0, _protectableTotal - domPrice);
        _compareTotal = Math.max(0, _compareTotal - domPrice);
        _count = Math.max(0, _count - 1);
      }
    }
    _render();
    _dispatchOptimisticProgress();
  }

  function optimisticToggleSP(enabled) {
    window._CART_OPTIMISTIC_SEQ++;
    _spOverride = enabled;
    _render();
    _dispatchOptimisticProgress();
  }

  // InstantCart's click-frame prediction (assets/cart-instant.js): a whole
  // predicted cart with its exact total, so every figure the footer shows is
  // the one the server is about to print. _offset carries over untouched, so
  // a discount code on the cart stays in the predicted total.
  function applyPrediction(p) {
    if (!p || !p.cart) return;
    window._CART_OPTIMISTIC_SEQ++;
    _productTotal = (typeof getProductOnlyTotal === 'function') ? getProductOnlyTotal(p.cart) : _productTotal;
    _protectableTotal = p.protectable || 0;
    _count = typeof p.count === 'number' ? p.count : _count;
    _spOverride = null;
    // p.total = server total + the change; recover the offset it implies so
    // a later legacy mutation keeps building on the same base
    if (typeof p.total === 'number') _offset = p.total - _productTotal - _spCents(_protectableTotal);
    if (_savings === null) _savings = _readSavingsFromDOM();
    _savings = Math.max(0, _savings + (p.savingsDelta || 0));
    _render();
    _dispatchOptimisticProgress();
  }

  function reconcile(cartState, opts) {
    if (!cartState || !cartState.items || cartState.items_subtotal_price === undefined) return;
    _fromCart(cartState, !!(opts && opts.serverFooter));
    _render();
  }

  function reapply() { _render(); }

  function revert() {
    if (window._cartState) {
      _fromCart(window._cartState);
      // the upgrade card and the protection slot go back to the real cart too
      if (window._cartState.items) _syncRegions(window._cartState.items);
    }
    _render();
  }

  // ShippingProtection's view of a cart it just synced: protection lines never
  // count toward the SAVE pill, so the pill stays as it is
  function displayForCart(cartState) {
    if (!cartState || !cartState.items || cartState.items_subtotal_price === undefined) return;
    const keep = _savings;
    _fromCart(cartState, true);
    if (keep !== null) _savings = keep;
    _render();
  }

  function getProductTotal() { return _productTotal; }

  function syncGiftProgress() { _dispatchOptimisticProgress(); }

  window.CartOptimist = {
    applyPrediction: applyPrediction,
    optimisticAdd: optimisticAdd,
    optimisticRemove: optimisticRemove,
    optimisticQuantity: optimisticQuantity,
    optimisticToggleSP: optimisticToggleSP,
    reconcile: reconcile,
    reapply: reapply,
    revert: revert,
    displayForCart: displayForCart,
    getProductTotal: getProductTotal,
    parseMoneyToCents: _parseMoneyToCents,
    syncGiftProgress: syncGiftProgress,
  };
})();

function mergeFooterStructure(oldFooter, newFooter) {
  if (!newFooter) return;

  var oldCmp = oldFooter.querySelector('.totals__old-price');
  var newCmp = newFooter.querySelector('.totals__old-price');
  if (newCmp && !oldCmp) {
    var disc = oldFooter.querySelector('.totals__discounted-prices');
    if (disc) disc.insertAdjacentHTML('beforeend', newCmp.outerHTML);
  }

  var oldBadge = oldFooter.querySelector('.badge.price__badge-sale');
  var newBadge = newFooter.querySelector('.badge.price__badge-sale');
  if (newBadge && !oldBadge) {
    var disc2 = oldFooter.querySelector('.totals__discounted-prices');
    if (disc2) disc2.insertAdjacentHTML('beforeend', newBadge.outerHTML);
  }

  var newDisc = newFooter.querySelector('.discounts');
  var oldDisc = oldFooter.querySelector('.discounts');
  if (newDisc && oldDisc) {
    oldDisc.innerHTML = newDisc.innerHTML;
  } else if (newDisc && !oldDisc) {
    oldFooter.insertAdjacentHTML('beforeend', newDisc.outerHTML);
  } else if (!newDisc && oldDisc) {
    oldDisc.remove();
  }
}

function getAddonConfig() {
  const el = document.getElementById('cart-drawer-addon-data');
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
}

function hasSubscriptionInCart() {
  const items = window._cartState?.items;
  if (!items) return false;
  return items.some(item =>
    item.product_type === window.cartStrings?.subscriptionProductType &&
    item.selling_plan_allocation
  );
}

function getNextAvailableAddon(excludeHandles) {
  const config = getAddonConfig();
  if (!config || !config.products) return null;
  const subscriptionInCart = hasSubscriptionInCart();
  return config.products.find(p =>
    p.available &&
    !excludeHandles.includes(p.handle) &&
    !(subscriptionInCart && p.is_subscription)
  ) || null;
}

function buildAddonItemHTML(addonProduct, buttonText) {
  const fmt = typeof getMoneyNoDecimalsFormat === 'function' ? getMoneyNoDecimalsFormat() : '${{amount_no_decimals}}';

  const priceHTML = '<span class="price-item price-item--regular">' + formatMoney(addonProduct.price, fmt) + '</span>';

  const imgSrc = addonProduct.image || '';
  let typeInputs = '';
  if (addonProduct.type === 'Matt') {
    typeInputs = '<input type="hidden" name="properties[_is_product_matt]" value="true" />';
  }

  return '<div class="additional-product__item">'
    + '<div class="additional-product__container">'
    + (imgSrc ? '<div class="additional-product__image"><a href="' + addonProduct.url + '"><picture>'
      + '<img src="' + imgSrc + '" width="80" height="80" alt="' + addonProduct.title + '" />'
      + '</picture></a></div>' : '')
    + '<div class="additional-product__info">'
    + '<a class="additional-product__name additional-product__name--link" href="' + addonProduct.url + '">' + addonProduct.title + '</a>'
    + '<div class="additional-product__price-row">'
    + '<span class="additional-product__price">' + priceHTML + '</span>'
    + '<div class="additional-product__controls">'
    + '<product-form class="product-form">'
    + '<div class="product-form__error-message-wrapper" role="alert" hidden="">'
    + '<span class="product-form__error-message"></span></div>'
    + '<form class="form" method="post" action="/cart/add" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">'
    + '<input type="hidden" name="form_type" value="product">'
    + '<input type="hidden" name="utf8" value="✓">'
    + '<input type="hidden" name="id" value="' + addonProduct.variant_id + '">'
    + typeInputs
    + '<button class="additional-product__button" type="submit" name="add">'
    + (buttonText
        ? '<span class="additional-product__button-text">' + buttonText + '</span>'
            + '<span class="loading-overlay__spinner hidden"><svg class="spinner" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></span>'
        : '<span class="additional-product__button-hover">'
            + '<span class="additional-product__button-icon-wrapper" aria-hidden="true">'
            + '<span class="additional-product__button-icon">'
            + '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">'
            + '<path d="M7.5 8.42001V7.45001C7.5 5.20001 9.31 2.99001 11.56 2.78001C14.24 2.52001 16.5 4.63001 16.5 7.26001V8.64001" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>'
            + '<path d="M8.99983 22.75H14.9998C19.0198 22.75 19.7398 21.14 19.9498 19.18L20.6998 13.18C20.9698 10.74 20.2698 8.75 15.9998 8.75H7.99983C3.72983 8.75 3.02983 10.74 3.29983 13.18L4.04983 19.18C4.25983 21.14 4.97983 22.75 8.99983 22.75Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>'
            + '<path d="M15.4955 12.75H15.5045" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
            + '<path d="M8.49451 12.75H8.50349" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
            + '</svg>'
            + '</span></span>'
            + '<span class="loading-overlay__spinner hidden"><svg class="spinner" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></span>'
            + '</span>')
    + '</button></form></product-form></div></div></div></div>';
}

function showOptimisticAddonSection(addonProduct) {
  const cartDrawer = document.querySelector('cart-drawer');
  const drawerContent = cartDrawer?.querySelector('.drawer__content');
  if (!drawerContent || !addonProduct) return;

  const config = getAddonConfig();
  const heading = config?.heading || 'Popular Add-Ons';
  const buttonText = config?.button_text;
  const itemHTML = buildAddonItemHTML(addonProduct, buttonText);
  let addonSection = drawerContent.querySelector(':scope > .additional-product');

  if (addonSection) {
    const list = addonSection.querySelector('.additional-product__list');
    if (list) {
      list.innerHTML = itemHTML;
    }
    addonSection.style.cssText = '';
    addonSection.style.opacity = '1';
  } else {
    const sectionHTML = '<div class="additional-product">'
      + '<h3 class="additional-product__heading">' + heading + '</h3>'
      + '<div class="additional-product__list">' + itemHTML + '</div></div>';
    const footerWrap = drawerContent.querySelector('.cartfrawerfooterWrap');
    if (footerWrap) {
      footerWrap.insertAdjacentHTML('beforebegin', sectionHTML);
    } else {
      drawerContent.insertAdjacentHTML('beforeend', sectionHTML);
    }
  }
}

function updateOptimisticCartItemQuantity(item, quantity = 0) {
  const cartDrawer = document.querySelector('cart-drawer');

  if(!cartDrawer || !item) {
    return;
  }

  const itemKey = item.key;
  const itemQuantity = item.quantity;

  const newQuantity = quantity + itemQuantity;

  const cartItem = cartDrawer.querySelector(`[data-item-key="${itemKey}"]`);

  if (!cartItem) {
    return;
  }

  cartItem.classList.add('cart-item--optimistic-update');

  const cartItemQuantityInput = cartItem.querySelector(".js-cart-item-quantity");

  if(cartItemQuantityInput) {
    cartItemQuantityInput.dataset.previousQuantity = cartItemQuantityInput.value;
    cartItemQuantityInput.value = newQuantity;
  }

  const cartItemGwpQuantity = cartItem.querySelector(".js-cart-item-gwp-quantity");

  if(cartItemGwpQuantity) {
    cartItemGwpQuantity.dataset.previousQuantity = cartItemGwpQuantity.textContent;
    cartItemGwpQuantity.textContent = newQuantity;
  }
}

function revertOptimisticCartItemQuantity() {
  const cartDrawer = document.querySelector('cart-drawer');

  if(!cartDrawer) {
    return;
  }

  const cartItems = [...cartDrawer.querySelectorAll('.cart-item--optimistic-update')];

  if(!cartItems.length) {
    return;
  }

  cartItems.forEach(cartItem => {
    const cartItemQuantityInput = cartItem.querySelector(".js-cart-item-quantity");

    if(cartItemQuantityInput) {
      const previousQuantity = cartItemQuantityInput.dataset.previousQuantity;

      if(previousQuantity) {
        cartItemQuantityInput.value = previousQuantity;
        cartItemQuantityInput.removeAttribute('data-previous-quantity');
      }
    }

    const cartItemGwpQuantity = cartItem.querySelector(".js-cart-item-gwp-quantity");

    if(cartItemGwpQuantity) {
      const previousQuantity = cartItemGwpQuantity.dataset.previousQuantity;

      if(previousQuantity) {
        cartItemGwpQuantity.textContent = previousQuantity;
        cartItemGwpQuantity.removeAttribute('data-previous-quantity');
      }
    }

    cartItem.classList.remove('cart-item--optimistic-update');
  });
}

function initLogoutPopup() {
  const logoutButton = document.querySelector(".js-log-out-button");

  if (!logoutButton) return null;

  const logoutPopup = document.querySelector("#PopupCustomerLogout");

  if (!logoutPopup) return null;

  logoutButton.addEventListener("click", () => {
    logoutPopup.show();
  });

  const closeButton = logoutPopup.querySelector(".js-close-modal");

  if (!closeButton) return null;

  closeButton.addEventListener("click", () => {
    logoutPopup.hide();
  });
}

initLogoutPopup();

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  document.body.classList.remove(`overflow-hidden-${summaryElement.dataset.breakpoint}`);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const button = event.currentTarget;

    button.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      const cartItems = this.closest('cart-items, cart-drawer-items');
      if (cartItems) {
        /* Instant: the new quantity, row price, Total and SAVE pill are all
           computed on this frame (cart.js previewQuantity -> CartOptimist),
           so the step shows no spinner and no shimmer; the debounced change
           below sends it, and the server answer only confirms it. */
        this.querySelectorAll('.cart-control-loading').forEach((loadingButton) => {
          loadingButton.classList.remove('cart-control-loading');
          loadingButton.removeAttribute('aria-busy');
        });
        const line = parseInt(this.input.dataset.index, 10);
        if (cartItems.tagName === 'CART-DRAWER-ITEMS' && line && typeof cartItems.previewQuantity === 'function') {
          cartItems.previewQuantity(line, parseInt(this.input.value, 10));
        } else {
          /* the /cart page summary (line totals, You save, protection row)
             is not predicted, so it keeps saying "working on it" instead of
             showing numbers that are about to change */
          button.classList.add('cart-control-loading');
          button.setAttribute('aria-busy', 'true');
          this.classList.add('cart-quantity-loading');
          this.setAttribute('aria-busy', 'true');
          const cartItem = this.closest('.cart-item');
          if (cartItem) {
            cartItem.classList.add('cart-price-loading');
            cartItem.setAttribute('aria-busy', 'true');
          }
          const total = document.querySelector('#main-cart-footer .cart__totals');
          if (total) {
            total.classList.add('cart-total-loading');
            total.setAttribute('aria-busy', 'true');
          }
        }
        this.input._cartTriggerButton = button;
      }
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function initSubscriptionTripodCheckbox() {
  document.addEventListener("change", (event) => {
    if (event.target.matches("#tripod_already_has")) {
      handleTripodCheckbox(event.target);
    }
  });

  async function handleTripodCheckbox(checkbox) {
    if (!checkbox.checked) return;

    const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];

    try {
      const cart = await fetch("/cart.js").then(res => res.json());
      const tripodItem = cart.items.find(item => {
        return item.properties?._tripod_subscription_type === "tripod";
      });
      const mainItem = cart.items.find(item => {
        return item.properties?._tripod_subscription_type === "tripod";
      });

      const removeResponse = await fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: tripodItem.key,
          quantity: 0,
          sections: sectionsToRender
        })
      });

      const removeState = await removeResponse.json();

      const drawerEl = document.querySelector("cart-drawer");

      if (!mainItem) drawerEl.renderContents(removeState);

      if (mainItem) {
        const oldProps = mainItem.properties || {};
        const newProps = {
          ...oldProps,
          _tripod_discount: "true"
        };

        const changeResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: mainItem.key,
            properties: newProps,
            sections: sectionsToRender
          })
        });

        const state = await changeResponse.json();
        const parser = new DOMParser();
        const docDrawer = parser.parseFromString(state.sections['cart-drawer'], 'text/html');
        const docBubble = parser.parseFromString(state.sections['cart-icon-bubble'], 'text/html');

        const newDrawer = docDrawer.querySelector("cart-drawer");
        const currentDrawer = document.querySelector("cart-drawer");

        if (newDrawer && currentDrawer) {
          newDrawer.classList.add("active");
          currentDrawer.replaceWith(newDrawer);
        }

        const newBubble = docBubble.querySelector(".js-cart-count-bubble-wrapper");
        const currentBubble = document.querySelector(".js-cart-count-bubble-wrapper");

        if (newBubble && currentBubble) {
          currentBubble.replaceWith(newBubble);
        }
      }

    } catch (err) {
      console.error("Tripod checkbox error:", err);
    }
  }
}

initSubscriptionTripodCheckbox();

document.addEventListener("tripod:delete", async (event) => {
  await handleMainItemRemoval(event.detail.key);
});

async function handleMainItemRemoval(itemKey) {
  const sectionsToRender = ["cart-drawer", "cart-icon-bubble"];
  const cartDrawerItems = document.querySelector('cart-drawer-items');

  // --- Phase 1: immediate visual feedback for the clicked item ---
  // Applied BEFORE the /cart.js fetch so the item collapses instantly on click.
  let clickedLineIndex = null;
  try {
    const clickedEl = cartDrawerItems?.querySelector(`[data-item-key="${CSS.escape(itemKey)}"]`);
    if (clickedEl) {
      const m = (clickedEl.id || '').match(/(\d+)$/);
      if (m) clickedLineIndex = parseInt(m[1]);
    }
    if (cartDrawerItems && clickedLineIndex) {
      cartDrawerItems.animateItemRemoval(clickedLineIndex);
      cartDrawerItems._setOtherCartItemsDisabled(true, [clickedLineIndex]);
      cartDrawerItems._setUpsellButtonsDisabled(true);
    }
    window._CART_DELETION_PENDING = true;
  } catch (e) {}

  const cart = await fetch("/cart.js").then(res => res.json());
  const itemToRemove = cart.items.find((item) => item.key === itemKey);

  if (!itemToRemove) return;

  const tripodType = itemToRemove.properties?._tripod_subscription_type;
  const updates = {
    [itemKey]: 0
  };

  if (tripodType === "main") {
    const relatedTripodItem = cart.items.find((item) => {
      const currentType = item.properties?._tripod_subscription_type;
      return currentType === "tripod";
    });

    if (relatedTripodItem) {
      updates[relatedTripodItem.key] = 0;
    }
  }

  const removedItemIds = cart.items
    .filter((item) => Object.prototype.hasOwnProperty.call(updates, item.key))
    .map((item) => item.id);

  cart.items
    .filter((item) => {
      return item.properties['_gwp-product'] && removedItemIds.includes(+item.properties['_gwp-product-for']);
    })
    .forEach((item) => {
      updates[item.key] = 0;
    });

  const hasRealItemsAfterUpdates = cart.items.some((item) => {
    if (updates[item.key] === 0) return false;

    const handle = item.handle || '';
    const properties = item.properties || {};
    const isShippingProtection = handle.includes('shipping-protection');
    const isNavidium = handle.includes('navidium');
    const isSubscriptionSubProduct = Boolean(properties._subscription_bundle_main_sub_product_id);

    return !isShippingProtection && !isNavidium && !isSubscriptionSubProduct;
  });

  if (!hasRealItemsAfterUpdates) {
    cart.items.forEach((item) => {
      if ((item.handle || '').includes('shipping-protection')) {
        updates[item.key] = 0;
      }
    });
  }

  // --- Phase 2: extend optimistic UI to related items now that we know the full set ---
  const removedKeys = Object.keys(updates);
  const removedLineIndexes = cart.items
    .map((item, i) => (removedKeys.includes(item.key) ? i + 1 : null))
    .filter(Boolean);

  try {
    if (cartDrawerItems && removedLineIndexes.length) {
      // Animate any related items not yet handled (e.g. tripod when subscription is main)
      removedLineIndexes.forEach(i => {
        if (i !== clickedLineIndex) cartDrawerItems.animateItemRemoval(i);
      });
      // Widen the overlay exclusion to the full removal set
      cartDrawerItems._setOtherCartItemsDisabled(true, removedLineIndexes);
    }
    if (window.CartOptimist) CartOptimist.optimisticRemove(removedLineIndexes);

    // If no real items remain, immediately show empty-cart state
    if (!hasRealItemsAfterUpdates) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.add('is-empty');
      if (cartDrawerItems) {
        cartDrawerItems.classList.add('is-empty');
        cartDrawerItems.style.display = 'none';
      }
    }
  } catch (e) {}

  const response = await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      updates,
      sections: sectionsToRender
    })
  });

  const state = await response.json();

  window._CART_DELETION_PENDING = false;
  // Update _cartState before DOM replacement so connectedCallback-driven
  // filterSlidesByCart() sees the post-deletion cart (not the stale state).
  window._cartState = state;

  const parser = new DOMParser();
  const docDrawer = parser.parseFromString(state.sections['cart-drawer'], 'text/html');
  const docBubble = parser.parseFromString(state.sections['cart-icon-bubble'], 'text/html');

  const newDrawer = docDrawer.querySelector("cart-drawer");
  const currentDrawer = document.querySelector("cart-drawer");

  if (newDrawer && currentDrawer) {
    newDrawer.classList.add("active");
    currentDrawer.replaceWith(newDrawer);
  }

  const newBubble = docBubble.querySelector(".js-cart-count-bubble-wrapper");
  const currentBubble = document.querySelector(".js-cart-count-bubble-wrapper");

  if (newBubble && currentBubble) {
    currentBubble.replaceWith(newBubble);
  }

  // Reconcile count/subtotal with the real server response
  if (window.CartOptimist) CartOptimist.reconcile(state);

  // Suppress shipping-protection widget immediately — without this it briefly
  // appears in the gap between replaceWith() and initCartDrawerDefaultState resolving.
  if (window.ShippingProtection) {
    try {
      ShippingProtection.hideCartItems();
      ShippingProtection.syncCart(state);
    } catch (e) {}
  }

  // `initCartDrawerDefaultState` (fired from the new cart-drawer's constructor)
  // replaces DOM elements asynchronously, creating additional upsell-products
  // elements whose connectedCallback may fire before those renders settle.
  // Dispatching cart:state-updated here ensures every currently-connected
  // upsell-products re-evaluates after all synchronous DOM work is done.
  document.dispatchEvent(new CustomEvent('cart:state-updated', { detail: { cart: state } }));
}

window._cartState = null;
window._gwpCache = null;

function cacheGWPData(cart) {
  if (!cart || !cart.items) return;
  const gwpItem = cart.items.find(i => i.properties && i.properties['_gwp-product'] === 'true');
  if (gwpItem) {
    window._gwpCache = {
      title: gwpItem.product_title || gwpItem.title,
      image: gwpItem.image,
      subtitle: gwpItem.variant_title || '',
    };
  }
  if (!window._gwpCache) {
    const gwpEl = document.querySelector('.cart-item--gwp');
    if (gwpEl) {
      window._gwpCache = {
        title: gwpEl.querySelector('.cart-item--gwp__text strong')?.textContent?.trim() || '',
        image: gwpEl.querySelector('.cart-item--gwp__image')?.src || '',
        subtitle: gwpEl.querySelector('.cart-item--gwp__subtitle')?.textContent?.trim() || '',
      };
    }
  }
}

function initCartCache() {
  const seq = window._CART_OPTIMISTIC_SEQ;
  fetch('/cart.js', { cache: 'no-store' })
    .then(r => r.json())
    .then(cart => {
      window._cartState = cart;
      cacheGWPData(cart);
      // Seed CartOptimist with the real cart so `_count` is correct on first render.
      // Without this, parallel paths (initCartDrawerDefaultState → renderContents →
      // CartOptimist.reconcile) run with `_count = 0` and `_render()` wrongly toggles
      // `is-empty=true` on cart-drawer, which sticks to any upsell-products that
      // mount after — they read the stale class and stay in `--empty-cart` mode.
      // this snapshot predates any optimistic change made while it was in flight —
      // reconciling with it would wipe the just-added line back out of the drawer
      if (window.CartOptimist && seq === window._CART_OPTIMISTIC_SEQ) CartOptimist.reconcile(cart);
      document.dispatchEvent(new CustomEvent('cart:state-updated', { detail: { cart } }));
    })
    .catch(() => {});
}

initCartCache();

function updateCartAndProductJSON() {
  const seq = window._CART_OPTIMISTIC_SEQ;
  return fetch('/cart.js', { cache: 'no-store' })
      .then(r => r.json())
      .then(cartJson => {
        window._cartState = cartJson;
        cacheGWPData(cartJson);
        // same staleness rule as initCartCache
        if (window.CartOptimist && seq === window._CART_OPTIMISTIC_SEQ) CartOptimist.reconcile(cartJson);
        document.dispatchEvent(new CustomEvent('cart:state-updated', { detail: { cart: cartJson } }));

        const scriptTags = document.querySelectorAll('.js-data-product-object');

        if (!scriptTags.length) return;

        scriptTags.forEach(scriptTag => {
          const data = JSON.parse(scriptTag.textContent);

          data.cart = cartJson;

          scriptTag.textContent = JSON.stringify(data, null, 2);
        });
      })
      .catch(console.error);
}

function updateHeaderHeight() {
  const header = document.querySelector(".js-header-wrapper");

  if (!header) return;

  const root = document.querySelector(":root");

  root.style.setProperty("--header-height", `${header.offsetHeight}px`);
}

function updateAnnouncementBarHeight() {
  const announcementBar = document.querySelector(".js-announcement-bar") || document.querySelector(".js-promo-bar");

  if (!announcementBar) return;

  const root = document.querySelector(":root");

  root.style.setProperty("--announcement-bar-height", `${announcementBar.offsetHeight}px`);
}

window.addEventListener("DOMContentLoaded", () => {
  updateHeaderHeight();
  updateAnnouncementBarHeight();
});

window.addEventListener("resize", () => {
  updateHeaderHeight();
  updateAnnouncementBarHeight();
});

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.drawer = this.querySelector('.menu-drawer');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    document.querySelector('#header-overlay').addEventListener('click', this.closeMenuDrawer.bind(this));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const subMenu = detailsElement.querySelector('.menu-drawer__inner-submenu');
    const parentMenuElement = detailsElement.closest('.has-submenu');

    setTimeout(()=> {
      this.drawer.style.setProperty("--sub-menu-height", subMenu.scrollHeight + 72 + "px");
    }, 100)

    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 1199px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header') || this.closest('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.querySelectorAll('.dcCart').forEach((el) => el.classList.add('dark'));
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.querySelectorAll('.dcCart').forEach((el) => el.classList.remove('dark'));
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('modal-dialog-open');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    if (!this.hasAttribute('data-allow-background-media')) window.pauseAllMedia?.();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('modal-dialog-open');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    if (!this.hasAttribute('data-allow-background-media')) window.pauseAllMedia?.();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const sectionId = this.dataset.originalSection || this.dataset.section;
        const sellingPlanSource = html.querySelector(`#product-form-${sectionId} input[name="selling_plan"]`);
        const sellingPlanDest = document.querySelector(`#product-form-${this.dataset.section} input[name="selling_plan"]`);

        if (sellingPlanDest && sellingPlanSource) {
          sellingPlanDest.value = sellingPlanSource.value;
        } else if (sellingPlanDest && !sellingPlanSource) {
          sellingPlanDest.remove();
        } else if (!sellingPlanDest && sellingPlanSource) {
          const productForm = document.querySelector(`#product-form-${this.dataset.section} form`);
          if (productForm) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            input.value = sellingPlanSource.value;
            productForm.appendChild(input);
          }
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        document.dispatchEvent(new CustomEvent("variant:update"));
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;
    const submitTextEl = productForm.querySelector('[name="add"] .product-form__submit-text');
    const addButtonHover = productForm.querySelector('[name="add"] > span');

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) {
        if (submitTextEl) submitTextEl.textContent = text;
        else if (addButtonHover) addButtonHover.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      if (submitTextEl) submitTextEl.textContent = window.variantStrings.addToCart;
      else if (addButtonHover) addButtonHover.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const submitTextEl = button.querySelector('[name="add"] .product-form__submit-text')
      || button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    submitTextEl.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

window.onIgReady = () => {
  const campaigns = window.igData?.campaigns?.getAll?.() || [];

  const igCampaigns = campaigns
    .map(campaign => campaign?.id?.split('-').pop())
    .filter(Boolean)
    .join(',');

  const itemProperty = igCampaigns ? { _igCampaigns: igCampaigns } : undefined;

  window.igCustomData = { itemProperty };

};

(function () {
  const observedIgNodes = new WeakSet();
  let igBadgeRootObserverStarted = false;

  function getIgSavingsElements(badge) {
    const cartItem = badge.closest('.cart-item');

    if (cartItem) {
      const priceEl = cartItem.querySelector('.igPrice');
      const compareEl = cartItem.querySelector('.igComparePrice');

      if (priceEl && compareEl) {
        return { priceEl, compareEl };
      }
    }

    const pid = badge.dataset.productId;
    if (!pid) return {};

    return {
      priceEl: document.querySelector('.igPrice[data-product-id="' + pid + '"]'),
      compareEl: document.querySelector('.igComparePrice[data-product-id="' + pid + '"]')
    };
  }

  function fixIgSavingsBadge(badge) {
    if (!window.CartOptimist?.parseMoneyToCents || !badge) return;
    if (badge.textContent.trim().startsWith('0%')) { badge.style.display = 'none'; return; }
    const { priceEl, compareEl } = getIgSavingsElements(badge);
    if (!priceEl || !compareEl) { badge.style.display = 'none'; return; }
    const priceCents = window.CartOptimist.parseMoneyToCents(priceEl.textContent);
    const compareAtCents = window.CartOptimist.parseMoneyToCents(compareEl.textContent);
    if (compareAtCents <= priceCents || compareAtCents <= 0) { badge.style.display = 'none'; return; }
    const pct = Math.round((compareAtCents - priceCents) / compareAtCents * 100);
    if (pct <= 0) { badge.style.display = 'none'; return; }
    const suffix = (window.cartStrings && window.cartStrings.savingsBadgeSuffix) || 'OFF';
    const correct = pct + '% ' + suffix;
    badge.style.display = '';
    if (badge.textContent.trim() !== correct) badge.textContent = correct;
  }

  function observeIgNode(node) {
    if (!node || observedIgNodes.has(node)) return;
    igBadgeObserver.observe(node, { characterData: true, childList: true, subtree: true });
    observedIgNodes.add(node);
  }

  function registerIgBadge(badge) {
    if (!badge) return;

    const { priceEl, compareEl } = getIgSavingsElements(badge);

    observeIgNode(badge);
    observeIgNode(priceEl);
    observeIgNode(compareEl);
    fixIgSavingsBadge(badge);
  }

  const igBadgeObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      if (!el) return;

      const badge = el.closest('.igSavingsPrice');
      if (badge) {
        fixIgSavingsBadge(badge);
        return;
      }

      const cartItem = el.closest('.cart-item');
      if (cartItem) {
        const cartBadge = cartItem.querySelector('.igSavingsPrice');
        if (cartBadge) {
          fixIgSavingsBadge(cartBadge);
        }
        return;
      }

      const priceMarker = el.closest('.igPrice, .igComparePrice');
      if (priceMarker && priceMarker.dataset.productId) {
        document.querySelectorAll('.igSavingsPrice[data-product-id="' + priceMarker.dataset.productId + '"]').forEach(fixIgSavingsBadge);
      }
    });
  });

  const igBadgeRootObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;
        if (node.matches('.igSavingsPrice[data-product-id]')) {
          registerIgBadge(node);
        }
        node.querySelectorAll('.igSavingsPrice[data-product-id]').forEach(registerIgBadge);
      });
    });
  });

  function setupIgBadgeObserver() {
    document.querySelectorAll('.igSavingsPrice[data-product-id]').forEach(registerIgBadge);

    if (!igBadgeRootObserverStarted && document.body) {
      igBadgeRootObserver.observe(document.body, { childList: true, subtree: true });
      igBadgeRootObserverStarted = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupIgBadgeObserver);
  } else {
    setupIgBadgeObserver();
  }

  document.addEventListener('variant:update', setupIgBadgeObserver);
}());
